// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__fFspY","choiceBoxes":"toolbarselects_choiceBoxes__3UytK","simpleField":"toolbarselects_simpleField__1eiMP"};